import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg-black py-36 flex flex-col items-center justify-center min-h-[29rem]" }, [
      _createElementVNode("h2", { class: "text-5xl" }, "¡GRACIAS POR INSCRIBIRTE!"),
      _createElementVNode("h2", { class: "text-xl mt-5" }, "YA FORMAS PARTE DE CORDOBA TECH WEEK ")
    ], -1))
  ], 64))
}